export const lerp = (a, b, t) => a + (b-a) * t